/**
 * FILE: assets/quote-request-page.js  (FLIR CAMERA STORE)
 *
 * Identical to the OEM Cameras version except for the store identity:
 *   - STORE_NAME constant drives the email subject (via {{title}}) and the
 *     company label, so quotes from this store are distinguishable in the
 *     shared EmailJS inbox WITHOUT any change to the EmailJS template.
 * Same EmailJS account/service/template/public key as OEM Cameras.
 */

// ─── Store identity (ONLY thing that differs from OEM Cameras) ─────
const STORE_NAME = 'FLIR Camera';

// ─── EmailJS Config (shared account — do not change) ──────────────
const EMAILJS_PUBLIC_KEY      = 'pBMmCWpQj2XXcpgcD';
const EMAILJS_SERVICE_ID      = 'service_dlwdt1c';
const EMAILJS_TEMPLATE_ID     = 'template_sze7clp';
const EMAILJS_AUTOREPLY_ID    = 'template_byxchun';
const RECAPTCHA_SITE_KEY      = '6Ld8OCITAAAAAKyLazLiblKor17fAaAq00aMg5YM';

// Load EmailJS SDK dynamically
(function loadEmailJS() {
  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
  script.onload = () => emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });
  document.head.appendChild(script);
})();

// Load reCAPTCHA SDK - auto-renders via data-sitekey on the div
(function loadRecaptcha() {
  const script = document.createElement('script');
  script.src = 'https://www.google.com/recaptcha/api.js';
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
})();

document.addEventListener('DOMContentLoaded', () => {
  const itemsList     = document.getElementById('quote-items-list');
  const emptyState    = document.getElementById('quote-empty-state');
  const clearBtn      = document.getElementById('clear-quote-btn');
  const hiddenInput   = document.getElementById('hidden-quote-items');
  const submitBtn     = document.getElementById('submit-quote-btn');
  const validationMsg = document.getElementById('quote-validation-msg');
  const form          = document.getElementById('quote-contact-form');

  if (!itemsList) return; // Not on the quote page

  function renderItems() {
    const items = QuoteCart.getItems();

    // Remove existing rendered rows (keep the empty state div)
    itemsList.querySelectorAll('.quote-item-row').forEach(el => el.remove());

    if (items.length === 0) {
      emptyState.style.display = 'block';
      clearBtn.style.display = 'none';
    } else {
      emptyState.style.display = 'none';
      clearBtn.style.display = 'inline-block';

      items.forEach(item => {
        const row = document.createElement('div');
        row.className = 'quote-item-row';
        row.dataset.variantId = item.variantId;
        row.innerHTML = `
          <div class="col-product">
            <button class="remove-item-btn" data-variant-id="${item.variantId}" aria-label="Remove ${item.title}">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
            ${item.image
              ? `<img src="${item.image}" alt="${item.title}" class="quote-item-image" />`
              : '<div class="quote-item-image-placeholder"></div>'
            }
            <div class="quote-item-details">
              <a href="/products/${item.handle}" class="quote-item-title">${item.title}</a>
              ${item.variantTitle && item.variantTitle !== 'Default Title'
                ? `<span class="quote-item-variant">${item.variantTitle}</span>`
                : ''
              }
            </div>
          </div>
          <div class="col-qty">
            <div class="qty-control">
              <button class="qty-btn qty-minus" data-variant-id="${item.variantId}">−</button>
              <input
                type="number"
                class="qty-input"
                value="${item.quantity}"
                min="1"
                data-variant-id="${item.variantId}"
                aria-label="Quantity for ${item.title}"
              />
              <button class="qty-btn qty-plus" data-variant-id="${item.variantId}">+</button>
            </div>
          </div>
        `;
        itemsList.appendChild(row);
      });
    }

    // Update hidden input with human-readable quote summary for email
    if (hiddenInput) {
      hiddenInput.value = formatQuoteForEmail(items);
    }
  }

  function formatQuoteForEmail(items) {
    if (items.length === 0) return 'No items in quote.';
    let text = 'QUOTE REQUEST ITEMS:\n\n';
    items.forEach((item, idx) => {
      text += `${idx + 1}. ${item.title}`;
      if (item.variantTitle && item.variantTitle !== 'Default Title') {
        text += ` (${item.variantTitle})`;
      }
      text += ` — Qty: ${item.quantity}\n`;
    });
    return text;
  }

  // Initial render
  renderItems();

  // Re-render when cart updates
  document.addEventListener('quote-cart:updated', renderItems);

  // Remove item
  itemsList.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('.remove-item-btn');
    if (removeBtn) {
      QuoteCart.removeItem(removeBtn.dataset.variantId);
      renderItems();
    }
    const minusBtn = e.target.closest('.qty-minus');
    if (minusBtn) {
      const vId = minusBtn.dataset.variantId;
      const item = QuoteCart.getItems().find(i => i.variantId === vId);
      if (item) {
        if (item.quantity <= 1) {
          QuoteCart.removeItem(vId);
        } else {
          QuoteCart.updateQuantity(vId, item.quantity - 1);
        }
        renderItems();
      }
    }
    const plusBtn = e.target.closest('.qty-plus');
    if (plusBtn) {
      const vId = plusBtn.dataset.variantId;
      const item = QuoteCart.getItems().find(i => i.variantId === vId);
      if (item) {
        QuoteCart.updateQuantity(vId, item.quantity + 1);
        renderItems();
      }
    }
  });

  // Qty input change
  itemsList.addEventListener('change', (e) => {
    if (e.target.classList.contains('qty-input')) {
      QuoteCart.updateQuantity(e.target.dataset.variantId, e.target.value);
      renderItems();
    }
  });

  // Clear all
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      if (confirm('Clear all items from your quote list?')) {
        QuoteCart.clearCart();
        renderItems();
      }
    });
  }

  // ─── Intercept form submission → send via EmailJS ─────────────────
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault(); // Stop Shopify contact form submission

      const items = QuoteCart.getItems();

      // Validate quote items
      if (items.length === 0) {
        validationMsg.style.display = 'block';
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      validationMsg.style.display = 'none';

      // Update hidden field one last time
      if (hiddenInput) {
        hiddenInput.value = formatQuoteForEmail(items);
      }

      // Get form values
      const firstName  = document.getElementById('contact-first-name')?.value.trim() || '';
      const lastName   = document.getElementById('contact-last-name')?.value.trim() || '';
      const email      = document.getElementById('contact-email')?.value.trim() || '';
      const phone      = document.getElementById('contact-phone')?.value.trim() || 'N/A';
      const rawCompany = document.getElementById('contact-company')?.value.trim() || '';
      const country    = document.getElementById('contact-country')?.value.trim() || '';
      const province   = document.getElementById('contact-province')?.value.trim() || '';
      const address1   = document.getElementById('contact-address')?.value.trim() || '';
      const address2   = document.getElementById('contact-address2')?.value.trim() || '';
      const city       = document.getElementById('contact-city')?.value.trim() || '';
      const zip        = document.getElementById('contact-zip')?.value.trim() || '';
      const note       = document.getElementById('contact-note')?.value.trim() || 'N/A';

      // Append store label to company so this store is identifiable in the
      // shared inbox. "Acme Corp - FLIR Camera", or just "FLIR Camera" if blank.
      const company = rawCompany ? `${rawCompany} - ${STORE_NAME}` : STORE_NAME;

      // Build combined address
      const addressLine = [address1, address2].filter(Boolean).join(', ');
      const cityLine    = [city, province, zip].filter(Boolean).join(', ');
      const fullAddress = [addressLine, cityLine, country].filter(Boolean).join('\n');

      // TODO: Re-enable reCAPTCHA after EmailJS is confirmed working
      // let recaptchaResponse = '';
      // try {
      //   recaptchaResponse = grecaptcha.getResponse();
      // } catch(err) {
      //   alert('reCAPTCHA not loaded. Please refresh the page and try again.');
      //   return;
      // }
      // if (!recaptchaResponse) {
      //   alert('Please complete the reCAPTCHA verification.');
      //   return;
      // }

      // Show loading state
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';

      // Send quote email via EmailJS
      emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
        title       : `New Quote Request from ${STORE_NAME}`,
        from_name   : `${firstName} ${lastName}`,
        from_email  : email,
        name        : `${firstName} ${lastName}`,
        email       : email,
        phone,
        company,
        address     : fullAddress,
        quote_items : hiddenInput.value,
        note
      })
      .then(() => {
        // Send auto-reply to customer
        return emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_AUTOREPLY_ID, {
          from_name   : `${firstName} ${lastName}`,
          from_email  : email,
          name        : `${firstName} ${lastName}`,
          email       : email,
          quote_items : hiddenInput.value,
          title       : `New Quote Request from ${STORE_NAME}`
        });
      })
      .then(() => {
        // Show success message
        form.innerHTML = `
          <div class="quote-success-message">
            <h3>&#10003; Quote Request Submitted!</h3>
            <p>Thank you. Our team will review your request and get back to you shortly.</p>
          </div>
        `;
        // Clear cart
        QuoteCart.clearCart();
        renderItems();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch((err) => {
        console.error('EmailJS error:', err);
        submitBtn.disabled = false;
        submitBtn.textContent = 'Proceed To Submit Your Quote';
        grecaptcha.reset();
        alert('Something went wrong. Please try again.');
      });
    });
  }

});